/**
 * @generated SignedSource<<8028761d449c4e430b0c11d7208d3d48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MarkAsOption_node$data = {
  readonly __typename: string;
  readonly id: string;
  readonly ownershipEvent?: {
    readonly id: string;
  } | null;
  readonly pins?: ReadonlyArray<{
    readonly context: string;
    readonly id: string;
    readonly label: string | null;
  }> | null;
  readonly " $fragmentType": "MarkAsOption_node";
};
export type MarkAsOption_node$key = {
  readonly " $data"?: MarkAsOption_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"MarkAsOption_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MarkAsOption_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Pin",
          "kind": "LinkedField",
          "name": "pins",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "context",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "HasPinsInterface",
      "abstractKey": "__isHasPinsInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "ownershipEvent",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "HasOwnerPermissionsInterface",
      "abstractKey": "__isHasOwnerPermissionsInterface"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "377f6d8c10d7fd1f8e36223e161b0ffe";

export default node;
